// Generated with util/create-component.js
import FieldSet from './FieldSet';

export default FieldSet;
